import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Stack, Box } from '@atlaskit/primitives/compiled';
import { ContentMetricsTable } from './ContentMetricsTable.tsx';
import { mockContentMetrics } from '../__fixtures__/performanceInsightsMockData.ts';

import { OverallContentPerformance } from './OverallContentPerformance.tsx';

const i18n = defineMessages({
	placeholder: {
		id: 'performance-insights.content-metrics-tab-placeholder.non-final',
		defaultMessage: 'Content metrics',
		description:
			'This is a placeholder message for the Content metrics tab, which is under development. This message is shown in the header of the Content metrics tab and is only used for basic testing. It should be replaced with meaningful content in the future.',
	},
	description: {
		id: 'performance-insights.content-metrics-tab-description.non-final',
		defaultMessage:
			'Identify content with slower load times. Content performance is based on average load times from the last 7 days. Content marked as slow or average may benefit from optimization. To improve performance, take the recommended actions provided for each content.',
		description:
			'This is a description for the content metrics tab of the performance insights page. It is only viewable by admins and is part of the Confluence Administration section of Confluence. This message should provide an overview of the content metrics tab and how to use it to identify and optimize slow loading content.',
	},
});

const styles = cssMap({
	container: {
		width: '100%',
		marginBlockStart: token('space.300'),
	},
	tableSection: {
		marginTop: token('space.600'),
	},
	description: {
		marginBottom: token('space.200'),
	},
});

type ContentMetricsTabProps = {};

export const ContentMetricsTab = (_props: ContentMetricsTabProps) => {
	return (
		<>
			<Stack xcss={styles.container}>
				<Box xcss={styles.description}>
					<FormattedMessage {...i18n.description} />
				</Box>
				<OverallContentPerformance />
				<Box xcss={styles.tableSection}>
					<ContentMetricsTable items={mockContentMetrics} />
				</Box>
			</Stack>
		</>
	);
};
